// src/routes/AppRouter.jsx
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import clientRoutes from "./clientRoutes";
import adminRoutes from "./adminRoutes";
import authRoutes from "./authRoutes";

const router = createBrowserRouter([
  {
    path: "/",
    ...clientRoutes,
  },
  adminRoutes,
  authRoutes,
]);

const AppRouter = () => <RouterProvider router={router} />;

export default AppRouter;